import PageHeader from '../../../components/PageHeader';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import VehicleForm from './components/VehicleForm';

export default function EditVehicle() {
  return (
    <>
      <Sidebar active="Vehicles" />
      <Transitions>
        <PageHeader
          title="Editar Veículo"
          link="/vehicles"
        />
        <VehicleForm edit />
      </Transitions>
    </>
  );
}
